import { useReactiveVar } from "@apollo/client";
import React from "react";
import { PLAYER_CARDS_ENABLED } from "src/constants";
import { currentSport } from "src/services/ApolloService";

type PlayerCardNameProps = {
  children?: any;
  className?: string;
};

export const PlayerCardName = ({ className = "", children }: PlayerCardNameProps) => {
  const sport = useReactiveVar(currentSport);
  return PLAYER_CARDS_ENABLED && sport?.hasPlayerCards ? (
    <a className={`${className}`}>{children}</a>
  ) : (
    <div className={`${className}`}>{children}</div>
  );
};
